module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bg"
  }, [_c('div', {
    staticClass: "row button-placeholder"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "pull-left",
    attrs: {
      "id": 'dt-length-' + _vm.shopId.toString() + '-' + _vm.productId
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "inner clearfix"
  }, [_c('data-table', {
    attrs: {
      "length-handle": '#dt-length-' + _vm.shopId.toString() + '-' + _vm.productId,
      "dt-id": _vm.shopId.toString() + '-' + _vm.productId,
      "my-ajax": _vm.dataTableAjax,
      "columns": _vm.columns,
      "column-defs": _vm.columnDefs,
      "refresh": _vm.DTRefresh,
      "search": {
        handle: '.dt-df-box',
        placeholder: _vm.t('Name / Index / Ean')
      },
      "page-length": _vm.defaultFilter.pagination,
      "sort": false
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cc49fc46!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductStationaryAvailability/StationaryShop.vue
// module id = 1352
// module chunks = 2